var SubCategoriesView = require('./backgrounds');
var BaseView = require('../../../components/accordion-list/categories-director');
var CreateMixin = require('../../../components/mixins/create');

module.exports = Backbone.mixin(BaseView.extend({
  class: 'sub-category backgrounds',
  CategoriesView: SubCategoriesView,
  views: {},

  addNewEvent: function (event, data) {
    this.modalData = new INKIVE.ModalAdminBackground({ data: data });
    this.modal = INKIVE.Modal.modalWindow(this.modalData.getFormHtml(), {
      width: 850,
      headerIcon: 'icon-news',
      headerTitle: 'modal.title.new_background',
      buttons: [{
        title: INKIVE.TranslateHelper.translate('modal.buttons.create_background'),
        onClick: _.bind(this.createTemplate, this)
      }]
    });
  },

  loadButtons: function () {
    var deferred = $.Deferred();

    INKIVE.Tool.preloadBackgroundCategories(function () {
      var data = INKIVE.Tool._cache['backgroundCategories'];
      deferred.resolve(_.map(data, function (backgroundCategory) {
        return { key: backgroundCategory.id, tag: backgroundCategory.name, icon: 'fa fa-ellipsis-v' };
      }));
    });

    return deferred.promise();
  },

  initialize: function () {
    this.createButtonMargin = 31;
    this.modalData = new INKIVE.ModalAdminBackground();
    this.mode = 'template';
    this.addButtonText = 'tool.admin.new_background';
    this.createCallback = $.noop;

    BaseView.prototype.initialize.call(this);
    this.render();
  },

  _render: function () {
    BaseView.prototype._render.apply(this, arguments);
    this.$el.find('.wrapper').css('top', this.createButtonMargin + 'px');
  },

  toggleAcordionElement: function ($button, value) {
    var $container = $button.closest('dt');
    var $wrapper = $container.closest('.wrapper');
    var top = this.createButtonMargin - $container.position().top;

    BaseView.prototype.toggleAcordionElement.apply(this, arguments);
    $wrapper.css('top', value
      ? top + 'px'
      : this.createButtonMargin + 'px'
    );
  }
}), CreateMixin);
